import React from 'react'
import { Card, Drawer, Form, Icon, notification } from 'antd'
import { connect } from 'react-redux'
import FileViewer from 'react-file-viewer';

@Form.create()
class PDFFileView extends React.Component {
    state = {
        visible: true,
    }
    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }
    onError = () => {
        notification.error({
            message: 'File type not supported, try to download it.'
        })
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    componentDidMount() {
        console.log("called");
    }

    render() {
        const { linkUrl, ext } = this.props;
        return (
            <Drawer
                title={
                    <div>
                        {ext} {' '}
                        <button onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </button>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <FileViewer
                        fileType={ext}
                        filePath={linkUrl}
                        onError={this.onError} />
                </Card>

            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PDFFileView)
